import { PERMISSIONS, type Permission } from '@lms/shared-types';

export function resolveForbiddenFallbackPath(
  hasPermission: (permission: Permission) => boolean,
): string {
  if (hasPermission(PERMISSIONS.DASHBOARD_ACCESS)) return '/dashboard';
  if (hasPermission(PERMISSIONS.MIS_CURSOS_VER)) return '/mis-cursos';
  if (hasPermission(PERMISSIONS.EXPEDIENTE_VER)) return '/expediente';
  if (hasPermission(PERMISSIONS.PERFIL_VER)) return '/profile';
  return '/login';
}
